var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel", class: _vm.statusClass }, [
    _c(
      "div",
      {
        staticClass: "panel-header",
        staticStyle: { "background-color": "initial" }
      },
      [
        _c("div", { staticClass: "panel-title statused" }, [
          _vm._v(_vm._s(_vm.statusLabel))
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "panel-body" }, [
      _vm.item.task
        ? _c("p", [
            _c("small", { staticClass: "view-label" }, [_vm._v("Задача")]),
            _vm._v(" "),
            _c("span", { staticClass: "text-bolder" }, [
              _vm._v(_vm._s(_vm.item.task))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.item.short
        ? _c("p", [
            _c("small", { staticClass: "view-label" }, [_vm._v("Сделано")]),
            _vm._v(" "),
            _c("span", { staticClass: "text-bolder" }, [
              _vm._v(_vm._s(_vm.item.short))
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ee74c9e2", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee74c9e2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/work-item.vue
// module id = null
// module chunks = 